import { render } from "./MyTeam.vue?vue&type=template&id=ac8197e2"
import script from "./MyTeam.vue?vue&type=script&lang=js"
export * from "./MyTeam.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__